<template>
  <div class="progress-circle">
    <svg viewBox="0 0 36 36" class="circular-chart">
      <path
        class="circle-bg"
        d="M18 2.0845
           a 15.9155 15.9155 0 0 1 0 31.831
           a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        class="circle"
        :stroke-dasharray="percent + ', 100'"
        d="M18 2.0845
           a 15.9155 15.9155 0 0 1 0 31.831
           a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <text x="18" y="20.35" class="percentage">{{ Math.round(percent) }}%</text>
    </svg>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { toRefs } from 'vue'

const props = defineProps({
  min: { type: Number, required: true },
  max: { type: Number, required: true },
  value: { type: Number, required: true },
})

const { min, max, value } = toRefs(props)

const percent = computed(() => {
  const range = max.value - min.value
  const adjustedValue = value.value - min.value
  return (adjustedValue / range) * 100
})
</script>

<style scoped>
.progress-circle {
  width: 100%;
  height: 100%;
}

.circular-chart {
  display: block;
  max-width: 100%;
  max-height: 250px;
}

.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 3.8;
}

.circle {
  fill: none;
  stroke-width: 2.8;
  stroke: #00acc1;
  stroke-linecap: round;
  animation: progress 1s ease-out forwards;
  transform: rotate(0deg);
  transform-origin: center;
}

.percentage {
  fill: #fff;
  font-family: 'Arial', sans-serif;
  font-size: 7px;
  text-anchor: middle;
}
</style>